import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Store } from '@ngxs/store';
import { BorrowerValue } from 'app/models/dto/borrower-value.model';
import { SaveBorrowerValues } from 'app/store/borrower-value/borrower-value.actions';

@Component({
  selector: 'app-cross-sell-dialog',
  templateUrl: './cross-sell-dialog.component.html',
  styleUrls: ['./cross-sell-dialog.component.scss'],
  standalone: false
})
export class CrossSellDialogComponent implements OnInit {
  currentValue: string | null;
  updateInProgress: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: { marketingSmsOptIn: BorrowerValue, borrowerId: number },
    public dialogRef: MatDialogRef<CrossSellDialogComponent>,
    private store: Store) { }

  ngOnInit(): void {
    // load current status of borrower value
    this.currentValue = this.data.marketingSmsOptIn?.value;
  }

  closeModal() {
    this.dialogRef.close();
  }

  handleSelection(value) {
    this.currentValue = value;
  }

  handleSave() {
    this.updateInProgress = true;

    const update = { ...this.data.marketingSmsOptIn, value: this.currentValue };
    this.store.dispatch(new SaveBorrowerValues(this.data.borrowerId, [update] )).subscribe({
      next: () => {
        this.updateInProgress = false;
        this.closeModal();
      },
      error: (error) => {
        console.error('Error saving borrower values:', error);
        this.updateInProgress = false;
      }
    });

  }
}
